import React, { useState } from "react";
import ToggleSwitchContainer from "./ToggleSwitchContainer";
import { useAlertContext } from "src/hooks/use-alert";

const RoomContainer = ({ data }) => {
  const alert = useAlertContext();
  const [toggle, setToggle] = useState({});
  const [light, setLight] = useState();
  const [openToggle, setOpenToggle] = useState(false);
  const [checked, setChecked] = useState(false);

  const handleToggle = () => {
    setChecked(!checked);
    alert.setSuccess((prev) => [
      ...prev,
      {
        status: true,
        message: "Control propagated successfully",
        index: prev.length,
      },
    ]);
    setTimeout(() => {
      setToggle({ ...toggle, [light]: !toggle[light] });
    }, 700);
  };

  return (
    <div
      style={{
        display: "grid",
        gap: 5,
        justifyContent: "center",
        gridTemplateColumns: "20px 20px",
      }}
    >
      {data.lights.map((light, i) => {
        let color = true;
        if (toggle[light]) color = false;

        return (
          <div
            onClick={() => {
              setLight(light);
              setOpenToggle(true);
              setChecked(!color);
            }}
            key={i}
            style={{ backgroundColor: color ? "white" : "red", height: "12px" }}
          ></div>
        );
      })}
      {openToggle && (
        <ToggleSwitchContainer
          openToggle={openToggle}
          setOpenToggle={setOpenToggle}
          handleToggle={handleToggle}
          checked={checked}
        />
      )}
    </div>
  );
};

export default RoomContainer;
